import axios from "axios";
import { createStore } from "vuex";

export default createStore({
	state: {
		token: null,
		infoKelulusan: null,
		authenticating: true,
		loading: true,
	},
	getters: {
		isAuthenticated: (state) => !!state.token && !!state.infoKelulusan,
		getToken: (state) => state.token,
		getInfoKelulusan: (state) => state.infoKelulusan,
		isAuthenticating: (state) => state.authenticating,
		isLoading: (state) => state.loading,
	},
	mutations: {
		setToken(state, val) {
			state.token = val;
			localStorage.setItem("token", val);
		},
		setInfoKelulusan(state, val) {
			state.infoKelulusan = val;
		},
		clearAuth(state) {
			state.token = null;
			state.infoKelulusan = null;
			localStorage.removeItem("token");
		},
		stopAuthenticating(state) {
			state.authenticating = false;
		},
		stopLoading(state) {
			state.loading = false;
		},
	},
	actions: {
		async loadAuth({ commit, dispatch }) {
			const token = localStorage.getItem("token");
			commit("setToken", token);
			if (!token) {
				commit("stopAuthenticating");
				setTimeout(() => {
					commit("stopLoading");
				}, 500);
				return;
			}
			await dispatch("verifyToken");
		},
		async verifyToken({ commit }) {
			try {

				const { data } = await axios.post(
					"/kelulusan/info",
					{},
				);
				commit("setInfoKelulusan", data.data.info_kelulusan);
			} catch (error) {
				commit("clearAuth");
				console.error(error.response?.data?.message);
			} finally {
				commit("stopAuthenticating");
				setTimeout(() => {
					commit("stopLoading");
				}, 500);
			}
		},
		loginUser({ commit }, data) {
			commit("setToken", data.token);
			commit("setInfoKelulusan", data.info_kelulusan);
		},
		updateToken({ commit }, token) {
			commit("setToken", token);
		},
		logoutUser({ commit }) {
			commit("clearAuth");
		},
	},
	modules: {},
});
